import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=ff9231a6&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=ff9231a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9231a6",
  null
  
)

export default component.exports